import { Utilities } from "@vue-leaflet/vue-leaflet";

export const routingControlProps = {
  waypoints: {
    type: Array,
    default: () => [],
  },
  router: {
    type: Object,
    default: undefined,
  },
  plan: {
    type: Object,
    default: undefined,
  },
  fitSelectedRoutes: {
    type: [String, Boolean],
    default: "smart",
  },
  routeLine: {
    type: Function,
    default: undefined,
  },
  autoRoute: {
    type: Boolean,
    default: true,
  },
  routeWhileDragging: {
    type: Boolean,
    default: true,
  },
  routeDragInterval: {
    type: Number,
    default: 500,
  },
  waypointMode: {
    type: String,
    default: "connect",
  },
  useZoomParameter: {
    type: Boolean,
    default: false,
  },
  showAlternatives: {
    type: Boolean,
    default: false,
  },
  altLineOptions: {
		styles: [
			{color: 'black', opacity: 0.15, weight: 9},
			{color: 'white', opacity: 0.8, weight: 6},
			{color: 'blue', opacity: 0.5, weight: 2}
		]
	}
,
};

export const setupRoutingControl = (props) => {
  const options = Utilities.propsToLeafletOptions(props, routingControlProps);
  return { options, methods: {} };
};
